import BottomLine from '@/components/Elements/BottomLine.vue'



export default [
	BottomLine, 
]
	
